export default __webpack_public_path__ + "static/media/unicef.49290e16.png";